import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useFtpUserStore = defineStore('ftpUser', {
  state: () => ({
    ftpUserList: [],
  }),
  getters: {
  },
  actions: {
    async refreshFtpUserList(rootNodeId) {
      const response = await Api.ftpUser.getFtpUserList(rootNodeId);
      this.ftpUserList = response.data;
    },

    async createFtpUser(rootNodeId, payload) {
      const response = await Api.ftpUser.createFtpUser(rootNodeId, payload);
      this.ftpUserList.push(response.data);
    },

    async updateFtpUser(rootNodeId, ftpUserId, payload) {
      const response = await Api.ftpUser.updateFtpUser(rootNodeId, ftpUserId, payload);
      const index = this.ftpUserList.findIndex(user => user.id === ftpUserId);
      if (index !== -1) {
        this.ftpUserList[index] = response.data;
      }
    },

    async deleteFtpUser(rootNodeId, ftpUserId) {
      await Api.ftpUser.deleteFtpUser(rootNodeId, ftpUserId);
      this.ftpUserList = this.ftpUserList.filter(user => user.id !== ftpUserId);
    },
  },
})
